export const TOGGLE_PLACEMENT_MODE = 'TOGGLE_PLACEMENT_MODE';

export const togglePlacementMode = () => ({
  type: TOGGLE_PLACEMENT_MODE,
  payload: {
  },
});
